'use client'
import { DetailPageHeader } from '@/components/header/detail-page-header'
import { FLOWS_PATH } from '@/lib/flow-templates/slug'
/**
 * The app-shell header for a flow page: Flows / {Brand} flow. The loading
 * shell passes `brandName={null}`, which holds `Flows`.
 */
export function FlowHeaderInjector({
  brandName,
}: {
  brandName: string | null
}) {
  return (
    <DetailPageHeader
      parentLabel="Flows"
      parentHref={FLOWS_PATH}
      title={brandName === null ? null : `${brandName} flow`}
    />
  )
}
